import { useState, useRef, useEffect } from 'react';
import { useFormik } from 'formik';

import { Button } from "../../components/Shared/Button";
import { Input } from "../../components/Shared/Input";
import { TrashIcon } from '../../components/Shared/Icons';

import { deleteCourse } from '../../api/courses/teachers';

import "./modal.css";

function CourseHiddenStatusIcon({ hidden }) {
  if (!hidden) {
    return (
      <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M2.28578 12.3906C4.28372 7.48386 8.40579 4.33333 13 4.33333C17.5941 4.33333 21.7162 7.48386 23.7141 12.3906C23.873 12.7808 23.873 13.2192 23.7141 13.6094C21.7162 18.5161 17.5941 21.6667 13 21.6667C8.40579 21.6667 4.28372 18.5161 2.28578 13.6094C2.12691 13.2192 2.12691 12.7808 2.28578 12.3906ZM13 19.6621C16.7039 19.6621 20.0999 17.1023 21.829 13C20.0999 8.89768 16.7039 6.33787 13 6.33787C9.29599 6.33787 5.90007 8.89768 4.17089 13C5.90007 17.1023 9.29599 19.6621 13 19.6621ZM13 16.9501C10.8563 16.9501 9.1185 15.1816 9.1185 13C9.1185 10.8184 10.8563 9.04989 13 9.04989C15.1436 9.04989 16.8814 10.8184 16.8814 13C16.8814 15.1816 15.1436 16.9501 13 16.9501ZM13 14.9456C14.0558 14.9456 14.9117 14.0745 14.9117 13C14.9117 11.9255 14.0558 11.0544 13 11.0544C11.9441 11.0544 11.0882 11.9255 11.0882 13C11.0882 14.0745 11.9441 14.9456 13 14.9456Z" fill="#92929D"/>
      </svg>
    )
  }
  return (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M22.631 2.35652C22.2558 1.98938 21.6529 1.99271 21.2818 2.36399L17.4647 6.18316C15.9447 5.36928 14.2557 4.92424 12.5 4.92424C8.09837 4.92424 4.11574 7.72165 2.16484 12.1157C2.05622 12.3604 2.05622 12.6396 2.16484 12.8843C3.04605 14.869 4.34177 16.528 5.90341 17.7506L2.36156 21.2944C1.98771 21.6684 1.99111 22.2736 2.36911 22.6435C2.7443 23.0106 3.34722 23.0073 3.7183 22.636L7.53542 18.8168C9.05541 19.6307 10.7444 20.0758 12.5 20.0758C16.9017 20.0758 20.8843 17.2784 22.8352 12.8843C22.9439 12.6396 22.9439 12.3604 22.8352 12.1157C21.954 10.131 20.6583 8.47195 19.0967 7.24936L22.6385 3.70561C23.0124 3.33156 23.009 2.72639 22.631 2.35652ZM16.0519 7.59669C14.9398 7.09023 13.7379 6.81818 12.5 6.81818C8.99755 6.81818 5.78282 8.99629 4.07473 12.5C4.85734 14.1053 5.95623 15.4324 7.25418 16.3991L9.23343 14.4188C8.90217 13.8561 8.71216 13.2002 8.71216 12.5C8.71216 10.408 10.4081 8.71212 12.5 8.71212C13.1995 8.71212 13.8548 8.90173 14.4171 9.23236L16.0519 7.59669ZM15.7667 10.5812L17.7459 8.60086C19.0438 9.56763 20.1427 10.8947 20.9254 12.5C19.2173 16.0037 16.0025 18.1818 12.5 18.1818C11.2622 18.1818 10.0603 17.9098 8.94819 17.4033L10.583 15.7676C11.1453 16.0983 11.8005 16.2879 12.5 16.2879C14.592 16.2879 16.2879 14.592 16.2879 12.5C16.2879 11.7998 16.0979 11.1439 15.7667 10.5812ZM12.9822 10.668C12.8283 10.6276 12.6667 10.6061 12.5 10.6061C11.454 10.6061 10.6061 11.454 10.6061 12.5C10.6061 12.667 10.6277 12.8289 10.6683 12.9832L12.9822 10.668ZM12.0178 14.332L14.3318 12.0168C14.3724 12.1711 14.394 12.333 14.394 12.5C14.394 13.546 13.546 14.3939 12.5 14.3939C12.3334 14.3939 12.1718 14.3724 12.0178 14.332Z" fill="#FC5A5A"/>
    </svg>
  )
}

function CloseIcon() {
  return (
    <svg width="92" height="92" viewBox="0 0 92 92" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_1228_38688)">
    <circle cx="46" cy="42" r="24" fill="white"/>
    </g>
    <path d="M50 38L42 46" stroke="#131313" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M50 46L42 38" stroke="#131313" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <defs>
    <filter id="filter0_d_1228_38688" x="0" y="0" width="92" height="92" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feOffset dy="4"/>
    <feGaussianBlur stdDeviation="11"/>
    <feComposite in2="hardAlpha" operator="out"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0.0745098 0 0 0 0 0.0745098 0 0 0 0 0.0745098 0 0 0 0.1 0"/>
    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1228_38688"/>
    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1228_38688" result="shape"/>
    </filter>
    </defs>
    </svg>

  )
}

function EditCourseModal({
  onClose,
  title,
  hero_image_url,
  author_profile_image_url,
  author_name,
  video_url,
  description,
  onSubmit,
  hidden,
  id,
  onDelete,
  course,
}) {
  const initialValues = {
    title: title,
    video_url: video_url,
    hero_image_url: hero_image_url,
    author_profile_image_url: author_profile_image_url,
    author_name: author_name,
    description: description,
    hidden: hidden,
  }

  const formik = useFormik({
    onSubmit: onSubmit,
    initialValues: initialValues,
  });

  const ref = useRef();
  const authorProfileImgRef = useRef();
  const [courseImage, setCourseImage] = useState(`"${hero_image_url}"`);
  const [authorProfileImage, setAuthorProfileImage] = useState(`"${author_profile_image_url}"`);
  const [courseIsHidden, setCourseIsHidden] = useState(hidden);
  useEffect(() => {
    if (hero_image_url && hero_image_url.length > 0) {
      setCourseImage(hero_image_url);
    }
  }, []);

  useEffect(() => {
    if (author_profile_image_url && author_profile_image_url.length > 0) {
      setAuthorProfileImage(author_profile_image_url);
    }
  }, []);

  function onUpdateCourseImage() {
    const { current } = ref;
    if (current.files && current.files.length > 0) {
      const file = current.files[0];
      const reader = new FileReader();
      reader.onloadend = () => {
        const res = reader.result;
        setCourseImage(res);
        formik.setFieldValue('hero_image_url', file);
      }
      reader.readAsDataURL(file);
    }
  }

  function onUpdateAuthorProfileImg() {
    const { current } = authorProfileImgRef;
    if (current.files && current.files.length > 0) {
      const file = current.files[0];
      const reader = new FileReader();
      reader.onloadend = () => {
        const res = reader.result;
        setAuthorProfileImage(res);
        formik.setFieldValue('author_profile_image_url', file);
      }
      reader.readAsDataURL(file);
    }
  }

  async function onDeleteCourse() {
    const ok = window.confirm("Are you sure you want to delete this course?")
    if (ok) {
      try {
        await deleteCourse(id)
        onClose();
        onDelete(course);
      } catch (err) {
        console.log(err);
      }
    }
  }

  function onDeletCourseImage() {
    setCourseImage('');
    formik.setFieldValue('hero_image_url', '');
  }

  function onDeletAuthorProfileImg() {
    setAuthorProfileImage('');
    formik.setFieldValue('author_profile_image_url', '');
  }

  return (
      <div className="CourseModalContainerOverlay">
        <div className="CourseModalContainer">
            <div className="CourseModal">
              <form onSubmit={formik.handleSubmit}>
                <div className="CourseModalHeader">
                  <div className="CourseModalHeaderTitle">
                    Update Course
                  </div>
                  <div onClick={onClose} className="CourseModalClose">
                    <CloseIcon />
                  </div>
                </div>
                <div className="CourseHeroCoverContainer">
                <div className="CourseHeroCoverHeader">Course Cover</div>
                  
                  <div className="CourseHeroCover">
                    <div
                      className="CourseHeroCoverImg"
                      style={{ backgroundImage: `url("${courseImage}")` }}
                    />
                    <div className="CourseHeroCoverActionsContainer">
                      <div className="CourseHeroCoverActions">
                      <div>
                        <label className='Btn'>
                          <input
                            ref={ref}
                            type="file"
                            accept="image/*"
                            onChange={onUpdateCourseImage}
                          />
                          <div className='BtnText'>Update</div>
                        </label>
                      </div>
                        <Button
                          text="Delete"
                          onClick={onDeletCourseImage}
                        />
                      </div>
                      <div className="CourseHeroCoverSubText">
                        Thumbnail help your students recognize the course
                      </div>
                    </div>
                  </div>
                  <br />


                  <div className="CourseHeroCoverHeader">Author Profile Image</div>
                  
                  <div className="CourseHeroCover">
                    <div
                      className="CourseAuthorProfileImg"
                      style={{ backgroundImage: `url("${authorProfileImage}")` }}
                    />
                    <div className="CourseHeroCoverActionsContainer">
                      <div className="CourseHeroCoverActions">
                      <div>
                        <label className='Btn'>
                          <input
                            ref={authorProfileImgRef}
                            type="file"
                            accept="image/*"
                            onChange={onUpdateAuthorProfileImg}
                          />
                          <div className='BtnText'>Update</div>
                        </label>
                      </div>
                        <Button
                          text="Delete"
                          onClick={onDeletAuthorProfileImg}
                        />
                      </div>
                      <div className="CourseHeroCoverSubText">
                        Avatar help your student to recognize your course.
                      </div>
                    </div>
                  </div>

                  <div className="CourseViewContainer">
                    <div>
                      <div className="CourseViewHeader">Course View</div>
                      <div className="CourseViewSubHeader">Course will be shown in the course feed</div>
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <div
                        onClick={onDeleteCourse}
                        className="DeleteCourseIconContainer"
                      >
                        <TrashIcon />
                      </div>
                      <div
                        onClick={() => {
                          setCourseIsHidden(!courseIsHidden);
                          formik.setFieldValue("hidden", !courseIsHidden)
                        }}
                        className='CourseHiddenStatusIconContainer'
                        >
                        <CourseHiddenStatusIcon hidden={courseIsHidden}/>
                      </div>
                    </div>
                  </div>

                  <div className="CourseInfoContainer">
                    <div className="InputGroup">
                      <Input
                        id='title'
                        type='text'
                        name='title'
                        className=''
                        {...formik.getFieldProps('title')}
                        error={formik.touched.title && formik.errors.title}
                      />
                      <Input
                        id='author_name'
                        type='text'
                        name='author name'
                        className=''
                        {...formik.getFieldProps('author_name')}
                        error={formik.touched.author_name && formik.errors.author_name}
                      />
                    </div>
                    <Input
                      id='video_url'
                      type='text'
                      name='video url'
                      className=''
                      {...formik.getFieldProps('video_url')}
                      error={formik.touched.video_url && formik.errors.video_url}
                    />
                    <Input
                      id='description'
                      type='textarea'
                      name='description'
                      className=''
                      {...formik.getFieldProps('description')}
                      error={formik.touched.description && formik.errors.description}
                    />
                    <div className="CourseModalSubmit">
                      <Button
                        text="Update Course"
                        color="secondary"
                        type="submit"
                        block
                      />
                    </div>
                  </div>
                </div>
              </form>
            </div>
        </div>
    </div>
  )
}

export default EditCourseModal;
